import Vue from 'vue'
import { ValidationProvider, extend, ValidationObserver } from 'vee-validate'
import { required, min, confirmed } from 'vee-validate/dist/rules'

Vue.component('VInput', ValidationProvider)
Vue.component('VForm', ValidationObserver)

extend('required', {
  ...required,
  message: 'O campo {_field_} não pode ser nulo.',
})
extend('min', {
  ...min,
  message: 'O campo {_field_} é muito pequeno',
})
extend('confirmed', {
  ...confirmed,
  message: 'A confirmação de senha não confere',
})
